import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=1097339e&scoped=true"
import script from "./Dealers.vue?vue&type=script&lang=js"
export * from "./Dealers.vue?vue&type=script&lang=js"
import style0 from "./Dealers.vue?vue&type=style&index=0&id=1097339e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097339e",
  null
  
)

export default component.exports